import type { IActiveOrg } from '@/interface/base.interface'
import * as React from 'react'

interface ActiveOrgContextType {
  activeOrg: IActiveOrg
  setActiveOrg: (org: IActiveOrg) => void
}

export const ActiveOrgContext = React.createContext<ActiveOrgContextType | undefined>(undefined)
